import React from "react";
import PageTitleCard from "../../../templates/PageTitleCard";
import { carrerDetails } from "./details";
import CarrersubTitle from "../templates/CarrersubTitle";
import JobinformationCard from "../templates/JobinformationCard";
import {
  BuildingOfficeIcon,
  TagIcon,
  UserIcon,
  FolderIcon,
  MapPinIcon,
  CalendarDaysIcon,
  ChevronDoubleRightIcon,
} from "@heroicons/react/16/solid";
import IconCard from "../templates/IconCard";
import JobinfornationminiTitle from "../templates/JobinfornationminiTitle";
import JobinformationPara from "../templates/JobinformationPara";
import JobinformationMiniCard from "../templates/JobinformationMiniCard";
import "./carrerdetails.css";
import PageTitleHeading from "../../../templates/PageTitleHeading";
import PageHeading from "../../../../templates/PageHeading";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { BASEURL } from "../../../../../utils/BaseUrl";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BackHome from "../../../../templates/BackHome";
import _ from "lodash";
import BackPath from "../../../../templates/BackPath";
import Slash from "../../../../templates/Slash";
import RightArrow from "../../../../templates/RightArrow";
import CurrentPath from "../../../../templates/CurrentPath";
import SubHeadingText from "../../../../common/SubHeadingText";
import { truncateText } from "../../../../../common/function/ScroolTop";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const CarrerDetails = () => {
  const navigate = useNavigate();
  const today = new Date();

  const formattedDate = today.toISOString().split("T")[0];

  const { id } = useParams();
  const { data, isLoading } = useQuery({
    queryKey: "getjobById",
    queryFn: () =>
      axios.get(`${BASEURL}job/${id}`).then((res) => {
        return res?.data;
      }),
  });

  const encodeId = (id) => btoa(id.toString());
  const handleNavigate = () => {
    const encodedId = encodeId(id);
    navigate(`/apply-form/${encodedId}`);
  };

  return (
    <div>
      <PageTitleCard>
        <PageHeading>Job Details</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow />{" "}
          <BackPath path={"/careers"}>Careers</BackPath> <RightArrow />{" "}
          <CurrentPath>
            {truncateText(
              _.capitalize(
                _.truncate(data?.title, { length: 15, omission: "..." })
              )
            )}
          </CurrentPath>
        </div>
      </PageTitleCard>
      <div className="mx-auto container py-8 md:px-4 sm:px-4 max-sm:px-8">
        <SubHeadingText>{_.capitalize(data?.title)} Details</SubHeadingText>
        <div className="lg:flex justify-between md:block sm:block max-sm:block  py-8">
          <div className="lg:w-2/3 md:w-full sm:w-full max-sm:w-full lg:pr-10 md:pr-0 sm:pr-0 max-sm:pr-0">
            {isLoading ? (
              <>
                <div className="w-20 ">
                  <Skeleton className="w-full h-5 my-4 rounded-md" />
                </div>
                <Skeleton className="w-6 h-5  rounded-md" />
                <Skeleton className="w-6 h-5  rounded-md" />
                <Skeleton className="w-6 h-5  rounded-md" />
                <div className="w-60 mb-4">
                  <Skeleton className="w-full h-5  rounded-md" />
                </div>
                <div className="w-20 ">
                  <Skeleton className="w-full h-5 my-4 rounded-md" />
                </div>
                <Skeleton className="w-6 h-5  rounded-md" />
                <Skeleton className="w-6 h-5  rounded-md" />
                <Skeleton className="w-6 h-5  rounded-md" />
                <div className="w-60 mb-4">
                  <Skeleton className="w-full h-5  rounded-md" />
                </div>
                <div className="w-20 ">
                  <Skeleton className="w-full h-5 my-4 rounded-md" />
                </div>
                <Skeleton className="w-6 h-5  rounded-md" />
                <Skeleton className="w-6 h-5  rounded-md" />
                <Skeleton className="w-6 h-5  rounded-md" />
                <div className="w-60 mb-4">
                  <Skeleton className="w-full h-5  rounded-md" />
                </div>
                <div className="w-20 ">
                  <Skeleton className="w-full h-5 my-4 rounded-md" />
                </div>
                <Skeleton className="w-6 h-5  rounded-md" />
                <Skeleton className="w-6 h-5  rounded-md" />
                <Skeleton className="w-6 h-5  rounded-md" />
                <div className="w-60 mb-4">
                  <Skeleton className="w-full h-5  rounded-md" />
                </div>
              </>
            ) : (
              <>
                <CarrersubTitle>Job Context</CarrersubTitle>
                <p
                  dangerouslySetInnerHTML={{ __html: data?.description }}
                  className="my-4 lg:text-lg md:text-lg sm:text-md max-sm:text-md leading-8 text-mute-grey carrer-text"
                ></p>
                <CarrersubTitle>Job Responsibility</CarrersubTitle>
                <p
                  dangerouslySetInnerHTML={{ __html: data?.responsibilities }}
                  className="my-4 lg:text-lg md:text-lg sm:text-md max-sm:text-md leading-8 carrer-text text-mute-grey  "
                ></p>

                <CarrersubTitle>Job Requirements</CarrersubTitle>
                <p
                  dangerouslySetInnerHTML={{ __html: data?.requirements }}
                  className="my-4 lg:text-lg md:text-lg sm:text-md max-sm:text-md leading-8 carrer-text text-mute-grey "
                ></p>

                <CarrersubTitle>Why joinus</CarrersubTitle>
                <p
                  dangerouslySetInnerHTML={{ __html: data?.joinus }}
                  className="my-4 lg:text-lg md:text-lg sm:text-md max-sm:text-md leading-8 carrer-text text-mute-grey"
                ></p>
              </>
            )}

            <div className="lg:block md:hidden sm:hidden max-sm:hidden py-4">
              {formattedDate <= data?.deadline ? (
                <div>
                  <button
                    onClick={() => handleNavigate()}
                    className="py-3 px-6 bg-sport-yellow rounded-lg font-semibold text-lg "
                  >
                    Apply Now
                  </button>
                </div>
              ) : (
                <div className="w-full p-4 border rounded-lg bg-red-400 text-speed-red font-semibold text-lg">
                  Dead Line Expired
                </div>
              )}
            </div>
          </div>
          <div className="lg:w-1/3 md:w-full sm:w-full max-sm:w-full py-4">
            {isLoading ? (
              <Skeleton className="lg:w-10 h-80 p-4 px-6 rounded-xl" />
            ) : (
              <JobinformationCard>
                <CarrersubTitle>Jobs Information</CarrersubTitle>
                <JobinformationMiniCard>
                  <IconCard>
                    <BuildingOfficeIcon className="w-6 h-6 text-deep-grey" />
                  </IconCard>
                  <div>
                    <JobinfornationminiTitle>
                      Company Name
                    </JobinfornationminiTitle>
                    <JobinformationPara>Aswin cold forge</JobinformationPara>
                  </div>
                </JobinformationMiniCard>
                <JobinformationMiniCard>
                  <IconCard>
                    <TagIcon className="w-6 h-6 text-deep-grey" />
                  </IconCard>
                  <div>
                    <JobinfornationminiTitle>
                      Job Category
                    </JobinfornationminiTitle>
                    <JobinformationPara>{data?.category}</JobinformationPara>
                  </div>
                </JobinformationMiniCard>
                <JobinformationMiniCard>
                  <IconCard>
                    <TagIcon className="w-6 h-6 text-deep-grey" />
                  </IconCard>
                  <div>
                    <JobinfornationminiTitle>
                      Experience
                    </JobinfornationminiTitle>
                    <JobinformationPara>{data?.experience}</JobinformationPara>
                  </div>
                </JobinformationMiniCard>
                <JobinformationMiniCard>
                  <IconCard>
                    <UserIcon className="w-6 h-6 text-deep-grey" />
                  </IconCard>
                  <div>
                    <JobinfornationminiTitle>
                      Job Position
                    </JobinfornationminiTitle>
                    <JobinformationPara>{data?.position}</JobinformationPara>
                  </div>
                </JobinformationMiniCard>
                <JobinformationMiniCard>
                  <IconCard>
                    <FolderIcon className="w-6 h-6 text-deep-grey" />
                  </IconCard>
                  <div>
                    <JobinfornationminiTitle>Job Type</JobinfornationminiTitle>
                    <JobinformationPara>{data?.type}</JobinformationPara>
                  </div>
                </JobinformationMiniCard>
                <JobinformationMiniCard>
                  <IconCard>
                    <FolderIcon className="w-6 h-6 text-deep-grey" />
                  </IconCard>
                  <div>
                    <JobinfornationminiTitle>Salary</JobinfornationminiTitle>
                    <JobinformationPara>{data?.salary}</JobinformationPara>
                  </div>
                </JobinformationMiniCard>
                <JobinformationMiniCard>
                  <IconCard>
                    <MapPinIcon className="w-6 h-6 text-deep-grey" />
                  </IconCard>
                  <div>
                    <JobinfornationminiTitle>
                      Job Location
                    </JobinfornationminiTitle>
                    <JobinformationPara>{data?.location}</JobinformationPara>
                  </div>
                </JobinformationMiniCard>
                <JobinformationMiniCard>
                  <IconCard>
                    <CalendarDaysIcon className="w-6 h-6 text-deep-grey" />
                  </IconCard>
                  <div>
                    <JobinfornationminiTitle>Deadline</JobinfornationminiTitle>
                    <JobinformationPara>{data?.deadline}</JobinformationPara>
                  </div>
                </JobinformationMiniCard>
              </JobinformationCard>
            )}
          </div>
          <div className="lg:hidden md:block sm:block max-sm:block my-4">
            {formattedDate <= data?.deadline ? (
              <div>
                <button
                  onClick={() => handleNavigate()}
                  className="py-3 px-6 bg-sport-yellow rounded-lg font-semibold text-lg "
                >
                  Apply Now
                </button>
              </div>
            ) : (
              <div className="w-full p-4 border rounded-lg bg-red-400 text-speed-red font-semibold text-lg">
                Dead Line Expired
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarrerDetails;
